<script>
import { Event } from '../../plugins/bus';
import { GarageLocationStore } from '../../stores/GarageLocationStore';
import moment from 'moment';
import { DateFormat } from '@/plugins/date-filter';

export default {
    data() {
      return {
        defects: [],
        defectsToAction: [],
        defectsToSchedule: [],
        reviewDefects: [],
        openDefectNotices: [],
        completedDefectNotices: [],
        availableAssignees: [],
        totalReviewDefects: 0,
        totalOpenNotices: 0,
        totalCompletedNotices: 0,
        defectStatuses: [
          { id: 'Unknown', text: 'Unknown' },
          { id: 'Unactioned', text: 'Unactioned' },
          { id: 'Submitted', text: 'Submitted' },
          { id: 'Received', text: 'Received' },
          { id: 'ScheduledPendingReview', text: 'Scheduled Pending Review' },
          { id: 'CompletedPendingReview', text: 'Completed Pending Review' },
          { id: 'PendingResubmission', text: 'Pending Resubmission' },
          { id: 'Scheduled', text: 'Scheduled' },
          { id: 'Completed', text: 'Completed' }
        ],
        defectAssignment: {status: 'none', assigned: []}
      };
    },
    computed: {
      querystring() {
        if (!this.params) {
          return '';
        }
        return (
          '?' +
          Object.keys(this.params)
            .map(key => (this.params[key] ? key + '=' + this.params[key] : null))
            .filter(x => !!x)
            .join('&')
        );
      },
      params() {
        var filter = this.filterParams || {};
        return {
          garageLocationId: filter.garageLocationId || GarageLocationStore.data.userGarage,
          completedPage: this.completedOptions.page || 1,
          completedPageSize: this.completedOptions.itemsPerPage || 50,
          completedOrderBy: this.completedOptions.sortBy && this.completedOptions.sortBy.length >= 1 ? this.completedOptions.sortBy[0] : 'receivedDate',
          completedOrderByDescending: this.completedOptions.sortDesc && this.completedOptions.sortDesc.length >= 1 ? this.completedOptions.sortDesc[0] : false,
          openPage: this.openOptions.page || 1,
          openPageSize: this.openOptions.itemsPerPage || 50,
          openOrderBy: this.openOptions.sortBy && this.openOptions.sortBy.length >= 1 ? this.openOptions.sortBy[0] : 'receivedDate',
          openOrderByDescending: this.openOptions.sortDesc && this.openOptions.sortDesc.length >= 1 ? this.openOptions.sortDesc[0] : false,
          reviewPage: this.reviewOptions.page || 1,
          reviewPageSize: this.reviewOptions.itemsPerPage || 50,
          reviewOrderBy: this.reviewOptions.sortBy && this.reviewOptions.sortBy.length >= 1 ? this.reviewOptions.sortBy[0] : 'receivedDate',
          reviewOrderByDescending: this.reviewOptions.sortDesc && this.reviewOptions.sortDesc.length >= 1 ? this.reviewOptions.sortDesc[0] : false,
          unitId: filter.unitId,
          ednNumber: filter.ednNumber,
          freeText: filter.freeText,
          dateField: filter.dateField,
          startDate: filter.startDate,
          endDate: filter.endDate,
        };
      }
    },
    methods: {
      snapshot(obj) {
        return (
          Object.keys(obj)
            .map(key => (obj[key] ? key + '=' + obj[key] : null))
            .filter(x => !!x)
            .join('&')
        );
      },
      async getAvailableAssignees() {
        try {
          this.$wait.start('loading available assignees');
          var filter = this.filterParams || {};
          var garageLocationId = filter.garageLocationId || GarageLocationStore.data.userGarage;
          const response = await this.$api.get(`defect-notices/available-assignees?garageLocationId=${encodeURIComponent(garageLocationId)}`);
          const data = response.data;
          this.availableAssignees = data;
          return data;
        } catch (error) {
          this.$toast.error(error);
        } finally {
          this.$wait.end('loading available assignees');
        }
        return [];
      },
      async getPendingDefectNotices() {
        try {
          this.$wait.start('loading pending defects notices');
          const response = await this.$api.get(`defect-notices/pending-notices${this.querystring}`);
          const data = response.data;

          this.defectsToAction = data.noticesRequiringActioning;
          this.defectsToSchedule = data.noticesRequiringScheduling;
          return data.data;
        } catch (error) {
          this.$toast.error('There was an error getting pending defect notices');
        } finally {
          this.$wait.end('loading pending defects notices');
        }
        return [];
      },
      async getReviewDefects() {
        try {
          this.$wait.start('loading review defects');
          const response = await this.$api.get(`defect-notices/review-defects${this.querystring}`);
          const data = response.data;
          this.reviewDefects = data.reviewDefects.map(x => ({...x, statusText: this.defectStatuses.find(s => s.id === x.status).text}));
          this.totalReviewDefects = data.reviewDefectsTotal;
          return data.data;
        } catch (error) {
          this.$toast.error('There was an error getting review defects');
        } finally {
          this.$wait.end('loading review defects');
        }
        return [];
      },
      async getOpenDefectNotices() {
        try {
          this.$wait.start('loading open defects notices');
          const response = await this.$api.get(`defect-notices/open-notices${this.querystring}`);
          const data = response.data;
          this.openDefectNotices = data.openNotices;
          this.totalOpenNotices = data.openNoticesTotal;
          return data.data;
        } catch (error) {
          this.$toast.error('There was an error getting open defect notices');
        } finally {
          this.$wait.end('loading open defects notices');
        }
        return [];
      },
      async getCompletedDefectNotices() {
        try {
          this.$wait.start('loading completed defects notices');
          const response = await this.$api.get(`defect-notices/completed-notices${this.querystring}`);
          const data = response.data;
          this.completedDefectNotices = data.completedNotices;
          this.totalCompletedNotices = data.completedNoticesTotal;
          return data;
        } catch (error) {
          this.$toast.error(error);
//          this.$toast.error('There was an error getting completed defect notices');
        } finally {
          this.$wait.end('loading completed defects notices');
        }
        return [];
      },
      async getCompletedDefectCounts() {
        try {
          this.$wait.start('loading completed defects counts');
          const response = await this.$api.get(`defects/completed${this.querystring}`);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error getting completed defect counts');
        } finally {
          this.$wait.end('loading completed defects counts');
        }
        return [];
      },
      async getDefectNotice(id) {
        try {
          this.$wait.start('loading data');
          const response = await this.$api.get(`defect-notices/${id}`);

          const data = response.data;

          return data;
        } catch (error) {
          this.$toast.error('There was an error getting defect notice');
        } finally {
          this.$wait.end('loading data');
        }
        return [];
      },
      async getDefects() {
        try {
          if (!this.querystring || this.querystring.indexOf('=') < 0) {
            return [];
          }
          this.$wait.start('loading defects');
          const response = await this.$api.get(`defects${this.querystring}`);
          const data = response.data;
          this.defects = data.data;
          this.totalDefects = data.total;
          return this.defects;
        } catch (error) {
          this.$toast.error('There was an error getting defects');
        } finally {
          this.$wait.end('loading defects');
        }
        return [];
      },
      async getDefect(id) {
        try {
          this.$wait.start('loading defect');
          this.$wait.start('loading data');
          const response = await this.$api.get(`defects/${id}`);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error getting defect');
        } finally {
          this.$wait.end('loading defect');
          this.$wait.end('loading data');
        }
        return [];
      },
      async startDefectNotice(id) {
        try {
          this.$toast.success('Saving start time...');
          this.$wait.start('saving');
          const response = await this.$api.post(`defect-notices/${id}/start`);
          this.$toast.success('Defect notice time started');
          return response;
        } catch (error) {
          this.$toast.error('There was an error starting defect notice');
        } finally {
          this.$wait.end('saving');
        }
        return null;
      },
      async acceptDefect(id) {
        try {
          this.$wait.start('saving');
          const response = await this.$api.post(`defects/${id}/accept`);
          this.$bus.$emit(Event.DefectCompleted, response.data);
          return response;
        } catch (error) {
          this.$toast.error('There was an error saving defect');
        } finally {
          this.$wait.end('saving');
        }
        return null;
      },
      async rejectDefect(id, command) {
        try {
          this.$wait.start('saving');
          const response = await this.$api.post(`defects/${id}/reject`, command);
          this.$bus.$emit(Event.DefectRejected, response.data);
          return response;
        } catch (error) {
          if (error && error.response && error.response.data) {
              this.$toast.error(error.response.data);
          } else {
              this.$toast.error('There was an error saving defect');
          }
        } finally {
          this.$wait.end('saving');
        }
        return null;
      },
      async scheduleDefect(id, command) {
        try {
          this.$wait.start('saving');
          const response = await this.$api.post(`defects/${id}/schedule`, command);
          this.$bus.$emit(Event.DefectScheduled, response.data);
          return response;
        } catch (error) {
          if (error && error.response && error.response.data) {
              this.$toast.error(error.response.data);
          } else {
              this.$toast.error('There was an error saving defect');
          }
        } finally {
          this.$wait.end('saving');
        }
        return null;
      },
      async deletePhoto(id) {
        try {
          this.$wait.start('saving');
          const response = await this.$api.post(`defects/${id}/remove-photo`);
          this.$bus.$emit(Event.DefectPhotoDeleted, { id });
          return response;
        } catch (error) {
          this.$toast.error('There was an error removing defect photo');
        } finally {
          this.$wait.end('saving');
        }
        return null;
      },
      async completeDefect(id, command, initiatedFrom) {
        try {
          this.$wait.start('saving');
          const response = await this.$api.post(`defects/${id}/complete`, command);
          this.$bus.$emit(Event.DefectCompleted, {...response.data, initiatedFrom });
          return response;
        } catch (error) {
          if (error && error.response && error.response.data) {
              this.$toast.error(error.response.data);
          } else {
              this.$toast.error('There was an error saving defect');
          }
        } finally {
          this.$wait.end('saving');
        }
        return null;
      },
      async moveDefect(id, command) {
        try {
          this.$wait.start('saving');
          const response = await this.$api.post(`defects/${id}/move`, command);
          this.$bus.$emit(Event.DefectMoved, response.data);
          return response;
        } catch (error) {
          if (error && error.response && error.response.data) {
              this.$toast.error(error.response.data);
          } else {
              this.$toast.error('There was an error moving defect');
          }
        } finally {
          this.$wait.end('saving');
        }
        return null;
      },
      async addDefectNotice(id, add) {
        try {
          this.$wait.start('saving');
          const response = await this.$api.put(`defect-notices/${id}`, add);
          this.$toast.success(`'${add.ednNumber}' added`);
          return response;
        } catch (err) {
          let extraDetail = '';
          if (err && err.response && err.response.data && err.response.data.errors) {
            extraDetail = `: ${err.response.data.errors.join(', ')}`;
          }
          this.$toast.error(`Could not add '${add.ednNumber}'${extraDetail}`);
        } finally {
          this.$wait.end('saving');
        }
        return null;
      },
      async actionDefectNotice(id, model, newReceivedTotal) {
        try {
          this.$wait.start('saving');
          const response = await this.$api.put(`defect-notices/${id}/action`, {...model, newReceivedTotal});
          this.$toast.success(`'${model.ednNumber}' actioned`);
          return response;
        } catch (err) {
          let extraDetail = '';
          if (err && err.response && err.response.data && err.response.data.errors) {
            extraDetail = `: ${err.response.data.errors.join(', ')}`;
          }
          this.$toast.error(`Could not add '${add.ednNumber}'${extraDetail}`);
        } finally {
          this.$wait.end('saving');
        }
        return null;
      },
      async updateDefectNotice(id, update) {
        try {
          this.$wait.start('saving');
          const response = await this.$api.put(`defect-notices/${id}`, update);
          this.$toast.success(`'${update.ednNumber}' updated`);
          return response;
        } catch (err) {
          this.$toast.error(`Could not update '${update.ednNumber}'`);
          this.$toast.error(err);
        } finally {
          this.$wait.end('saving');
        }
        return null;
      },
      async receiveDefectNotice(id, update) {
        try {
          this.$wait.start('saving');
          const response = await this.$api.put(`defect-notices/${id}/receive`, update);
          this.$toast.success(`'${update.ednNumber}' updated`);
          return response;
        } catch (err) {
          this.$toast.error(`Could not update '${update.ednNumber}'`);
          this.$toast.error(err);
        } finally {
          this.$wait.end('saving');
        }
        return null;
      },
      async moveDefectNotice(id, newGarageId) {
        try {
          this.$wait.start('saving');
          const response = await this.$api.post(`defect-notices/${id}/move`, {newGarageId});
          this.$toast.success(`Defect Notice moved`);
          return response;
        } catch (err) {
          this.$toast.error(`Could not move Defect Notice`);
          this.$toast.error(err);
        } finally {
          this.$wait.end('saving');
        }
        return null;
      },
      storeDefectCompletionData(unitId, date, data) {
        var key = `${unitId}${date}`;
        localStorage.setItem(key, JSON.stringify(data));
      },
      getDefectCompletionData(unitId, date) {
        var key = `${unitId}${date}`;
        var json = localStorage.getItem(key);
        if (json) {
          return JSON.parse(json);
        }
        return {
          completedBy: '',
          completedDate: moment()
            .startOf('day')
            .format(DateFormat.Canonical),
          completionInterval: null,
          intervalType: 'Hours'
        };
      },
      async getScheduledReasons() {
        try {
          this.$wait.start('loading scheduled reasons');
          const response = await this.$api.get('scheduled-reasons');
          const data = response.data;
          return data;
        } catch (error) {
          this.$toast.error(error);
        } finally {
          this.$wait.end('loading scheduled reasons');
        }
        return [];
      },
      async getAssignmentStatus() {
        try {
          this.$wait.start('loading assignment status');
          const response = await this.$api.get(`defect-notices/assignments${this.querystring}`);
          this.defectAssignment = response.data;
          return this.defectAssignment;
        } catch (error) {
          this.$toast.error(error);
        } finally {
          this.$wait.end('loading assignment status');
        }
        return { status: 'none', assigned: [] };
      }
    }
  };
</script>
